import { Alert } from "@mui/material";

import { CAMPAIGN_TYPE_LABEL, IContractLifecycle } from "v2/services/contractLifecycle.service";

/**
 * Spec 29/09 §3.2: enquanto o contrato está Em implantação, Conferir movimentações avisa por
 * tipo, só para os Armados. Um tipo já Ativo (por exemplo, depois de uma reabertura) aparece
 * como ativo, sem aviso.
 */
export function ImplantacaoAviso({ lifecycle }: { lifecycle: IContractLifecycle | null }) {
  if (!lifecycle || lifecycle.state !== "EM_IMPLANTACAO") return null;
  const armados = lifecycle.campaignTypes.filter((t) => t.state === "ARMED");
  if (armados.length === 0) return null;
  return (
    <>
      {armados.map((t) => (
        <Alert key={t.type} severity="info" role="alert" sx={{ width: "100%", maxWidth: 1366, mb: 1 }}>
          {`Contrato em implantação: ${CAMPAIGN_TYPE_LABEL[t.type]} aguarda conclusão`}
        </Alert>
      ))}
    </>
  );
}
